module.exports = __webpack_public_path__ + "img/seminar (55).2b7ea9c4.jpg";